module.exports = __webpack_public_path__ + "img/countMoney.0a2be8bb.gif";